/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {agentCoreAgentWalletInitiatePayment} from '../api'

export const useMutationAgentCoreAgentWalletInitiatePayment = createReactQueryMutationHook('agentCoreAgentWalletInitiatePayment', agentCoreAgentWalletInitiatePayment)
